import axios from "axios";

export const api = axios.create({
  //baseURL: "https://tesb-api.easycob-n.com.br/", // api de teste
  baseURL: "https://boleto-api.easycob-n.com.br/", // api de prod
  //baseURL: "http://172.19.1.78:3001",
  //baseURL: "http://localhost:3001",

  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json; charset=utf-8",
  },
});
